import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

//Local modules
import { RegisterationModule } from './authentication/registration/registeration.module';
import { LoginModule } from './authentication/login/login.module';
import { CommonComponentModule } from './common/common-component.module';

//Query file
import { ScheduleQueryService } from './queryFiles/index';

const routes = [
    {
        path: 'e-commerce',
        loadChildren: './e-commerce/e-commerce.module#FuseEcommerceModule'
    },
    {
        path: 'calendar',
        loadChildren: './calendar/calendar.module#CalendarScheduleModule'
    },
    {
        path: 'users',
        loadChildren: './contacts/contacts.module#UsersContactModule'
    },
    {
        path: 'operations',
        loadChildren: './configuration/configuration.module#ConfigurationModule'
    },
    {
        path: 'permissions',
        loadChildren: './permission/permission.module#PermissionModule'
    },
    {
        path: 'bizDev',
        loadChildren: './configuration/market-company-affiliate/market-company-affiliate.module#MarketCompanyAffiliateModule'
    },
    {
        path: 'banner-reviews',
        loadChildren: './banner-reviews/banner-reviews.module#BannerReviewsModule'
    },
    {
        path: '404',
        loadChildren: './access-denied/access-denied.module#AccessDeniedModule'
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        //Local modules
        RegisterationModule,
        LoginModule,
        CommonComponentModule
    ],
    declarations: [],
    providers: [
        ScheduleQueryService
    ]
})
export class FuseAppsModule {
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/apps.module.ts